import { render, staticRenderFns } from "./attachmentList.vue?vue&type=template&id=70f74661&scoped=true&"
import script from "./attachmentList.vue?vue&type=script&lang=js&"
export * from "./attachmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f74661",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f74661')) {
      api.createRecord('70f74661', component.options)
    } else {
      api.reload('70f74661', component.options)
    }
    module.hot.accept("./attachmentList.vue?vue&type=template&id=70f74661&scoped=true&", function () {
      api.rerender('70f74661', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledgeBaseMgr/knowledgeMgr/components/attachmentList.vue"
export default component.exports